import { cx } from "classix";

type Props = {
  list: string[];
  className?: string;
};

export default function GridList({ list, className }: Props) {
  return (
    <ul
      className={cx(
        "text-r-xl mx-8 grid list-outside list-disc grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-2 font-bold text-green-400",
        className
      )}
    >
      {list.map((item) => (
        <li key={item}>{item}</li>
      ))}
    </ul>
  );
}
